import React from 'react';
import { Box, Typography } from '@mui/material';
import { tokens } from '../theme';
import fastTimeAppIcon from '../assets/fasttime-app-icon.png';

export default function BrandLogo({ subtle = false }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box
        component="img"
        src={fastTimeAppIcon}
        alt="FastTime"
        sx={{
          width: 36,
          height: 36,
          borderRadius: 1.2,
          objectFit: 'cover',
          boxShadow: subtle ? 'none' : '0 12px 24px rgba(0,0,0,0.22)',
        }}
      />
      <Typography
        variant="h6"
        sx={{
          fontSize: '1.8rem',
          fontFamily: '"Syne", "Oxygen", sans-serif',
          fontWeight: 700,
          color: subtle ? '#fff' : tokens.cream,
          letterSpacing: '-0.02em',
          lineHeight: 1,
        }}
      >
        FastTime
      </Typography>
    </Box>
  );
}
